
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/affordable-creative-marketing-automation",
      function () {
        return require("private-next-pages/articles/affordable-creative-marketing-automation.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/affordable-creative-marketing-automation"])
      });
    }
  